export const docUploadAnalytics = {
    constants: {
        pageNameNoVehicle: 'fv:dynamic manage:doc upload',
        pageID: 'dynamic manage',
        contentSubType: 'doc upload',
        pTemplate: 'none',
        linkType: 'cta',
        clickAction: 'click',
        loginStatus: 'logged-in',
        pageName: 'fv:dynamic manage:doc upload',
        tool: globalThis?.digitaldata?.page?.tool,
        errorTool: 'event:error tracking',
        errorActionTool: 'error|tool',
        pageType: 'fv:dynamic manage',
        nameplate: globalThis?.digitaldata?.vehicle?.nameplate || '',
        onLandSatelliteTrackId: 'dynamicManageDocUpload',
        webOnLandSatelliteTrackId: 'websdk-pageload',
        clickSatelliteTrackId: 'ecommInternalCtaClick',
        webClickSatelliteTrackId: 'websdk-ecomm-onclick',
        errorSatelliteTrackId: 'moduleErrorCtaClick',
        webErrorSatelliteTrackId: 'websdk-onclick'
    },
    prepareDataLayer: function (value) {
        return {
            page: {
                ...globalThis?.digitaldata?.page,
                tool: value === 'error states' ? `${this.constants.errorTool}` : `${this.constants.tool}`
            },
            onclick: {
                onclickLinkName: `${this.constants.pageNameNoVehicle}:${this.constants.linkType}:${value}:${this.constants.nameplate}`,
                onclick: `${this.constants.pageID}:${this.constants.contentSubType}:${this.constants.linkType} ${this.constants.clickAction}:${value}`,
                contentType: `${this.constants.pageID}:${this.constants.pTemplate}:${this.constants.clickAction}`,
                contentSubType: `${this.constants.contentSubType}`
            },
            event: {
                action: value === 'error states' ? `${this.constants.errorActionTool}` : `${this.constants.tool}`
            },
            user: {
                errorTracking: '',
                loginStatus: `${this.constants.loginStatus}`
            }
        }
    },
    prepareDataLayerForLanding: function () {
        return {
            page: {
                ...globalThis?.digitaldata?.page,
                tool: `${this.constants.tool}`
            },
            event: {
                action: `${this.constants.tool}`
            },
            user: {
                errorTracking: '',
                loginStatus: `${this.constants.loginStatus}`
            }
        }
    },
    backToDM: function () {
        return this.prepareDataLayer('back to dynamic manage')
    },
    uploadDoc: function (documentName) {
        return this.prepareDataLayer(`${documentName}:upload`)
    },
    cancel: function (documentName) {
        return this.prepareDataLayer(`${documentName}:cancel edit`)
    },
    delete: function (documentName) {
        return this.prepareDataLayer(`${documentName}:delete doc`)
    },
    confirmDelete: function (documentName) {
        return this.prepareDataLayer(`${documentName}:delete doc confirm`)
    },
    edit: function (documentName) {
        return this.prepareDataLayer(`${documentName}:edit doc`)
    },
    done: function (documentName) {
        return this.prepareDataLayer(`${documentName}:done`)
    },
    error: function (errorMessage) {
        const dataLayer = this.prepareDataLayer('error states')
        return {
            ...dataLayer,
            user: {
                errorTracking: errorMessage,
                loginStatus: `${this.constants.loginStatus}`
            }
        }
    },
    onLoad: function () {
        const updatedDataLayer = this.prepareDataLayerForLanding()
        globalThis.digitaldata = globalThis.digitaldata || {}
        globalThis.digitaldata = {
            ...globalThis.digitaldata,
            ...updatedDataLayer
        }
        console.log('doc upload analytics onLoad called')
        const satelliteTrackId = this.constants.onLandSatelliteTrackId
        if (globalThis?._satellite) {
            globalThis._satellite.track(satelliteTrackId)
        }

        const webSatelliteTrackId = this.constants.webOnLandSatelliteTrackId
        if (globalThis?._satellite) {
            globalThis._satellite.track(webSatelliteTrackId)
        }
    },
    track: function (eventName, value = '') {
        value = value.toLowerCase()
        const updatedDataLayer = this[eventName](value)
        globalThis.digitaldata = globalThis.digitaldata || {}
        if (globalThis?.digitaldata?.user?.errorTracking) {
            delete globalThis.digitaldata.user.errorTracking
        }
        globalThis.digitaldata = {
            ...globalThis.digitaldata,
            ...updatedDataLayer
        }

        const satelliteTrackId = updatedDataLayer?.user?.errorTracking
            ? this.constants.errorSatelliteTrackId
            : this.constants.clickSatelliteTrackId
        if (globalThis?._satellite) {
            globalThis._satellite.track(satelliteTrackId)
        }

        const webSatelliteTrackId = updatedDataLayer?.user?.errorTracking
            ? this.constants.webErrorSatelliteTrackId
            : this.constants.webClickSatelliteTrackId
        if (globalThis?._satellite) {
            globalThis._satellite.track(webSatelliteTrackId)
        }
    }
}
